import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { NavLink } from 'react-router-dom'

const TableRow = (props) => {
  return(
    <tr>
      <td>
        <NavLink to={`/inventory/${props.inventory.id}`}>
          {props.inventory.id}
          </NavLink>
        </td>
      <td>{props.inventory.item.name}</td>
      <td>{props.inventory.weight}</td>
      <td>{props.inventory.number_items}</td>
      <td>
        <NavLink className="btn btn-primary btn-sm mr-0" to={`/inventory/${props.inventory.id}`}>
          <i className="fa fa-eye"></i>
        </NavLink>
      </td>
    </tr>
  )
}

export default class ListProductionIntermediateLabels extends Component {

  constructor(props) {
    super(props);
    this.state = { isOpened: false }
  }

  toggleCollapse = () => {
    this.setState({isOpened: !this.state.isOpened});
  };

  render() {
    let borderTop={borderTop: "1px solid #dbdee0"}
    return (
      <div className="card mb-20">
        <div className="d-flex justify-content-between align-items-center card-header pointer" onClick={this.toggleCollapse}>
          <div className="d-flex">
            <h5 className="mr-05 mb-0">{this.props.title}</h5>
            {this.state.isOpened ? null : <span>{' (' + this.props.intermediate_labels.length + ')'} </span> }
          </div>
          <i className={`fa ${this.state.isOpened ? "fa-caret-up" : "fa-caret-down"}`}></i>
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="card-block p-0 m-0">
          {this.props.intermediate_labels.length ?
            <table className="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Item</th>
                  <th className="hidden-xs-down">Quantity</th><th className="hidden-sm-up">Qty</th>
                  <th className="hidden-xs-down">Pieces</th><th className="hidden-sm-up">Pcs</th>
                  <th className="hidden-xs-down">Actions</th><th className="hidden-sm-up">-</th>
                </tr>
              </thead>
              <tbody>
                {this.props.intermediate_labels.map((inventory,index)=>{
                  return(
                    <TableRow inventory={inventory} key={index} />
                  )
                })}
              </tbody>
            </table>
          :
            <div className="empty-table"><span>No products printed yet</span></div>
          }
          </div>
          <div className="card-header" style={borderTop}>
            <h6 className="mb-0">Number of Labels: {this.props.intermediate_labels.length}</h6>
          </div>
        </Collapse>
      </div>
    );
  }
}
